import { objectToQueryString } from '@/common/js/utils';
import {
    ICancelSubscriptionArgs,
    ICheckDeviceSubscriptionResponse,
    ICommonRes,
    IDataUsageRecord, IEsim,
    IGetDataUsageRecordsArgs,
    IGetPackagesArgs,
    IGetSubDeviceListArgs,
    IOkRes,
    IPackage,
    ISubDevice,
    ISubscription,
    IGetSubscriptionArguments
} from '@reolink-cloud/interface';
import { httpManager as http } from '@/plugins/HttpManager';
import { GetUserDataError } from '@/utils/error';

/**
 * 获取订阅视角下的设备信息
 * @returns
 */
export const getSubDeviceList = async ( args?: IGetSubDeviceListArgs ): Promise<ISubDevice[]> => {

    const { data } = await http.get<ICommonRes<ISubDevice>>( `/cloud/subscriptions/devices${objectToQueryString( args )}` );
    return data.items;

};

/**
 * 获取设备流量使用详细
 */
export const getDataUsageRecords = async ( args: IGetDataUsageRecordsArgs ): Promise<IDataUsageRecord[]> => {

    const qs = objectToQueryString( args );
    const { data } = await http.get<ICommonRes<IDataUsageRecord>>( `/devices/sim-cards/data/usage/${qs}` );

    return data.items;

};

/**
 * 获取流量包使用情况
 * @param args
 * @returns
 */
export const getPackages = async ( args: IGetPackagesArgs ): Promise<IPackage[]> => {

    const qs = objectToQueryString( args );

    const { data } = await http.get<ICommonRes<IPackage>>( `/devices/sim-cards/package/${qs}` );
    return data.items;

};

export const setAutoRenewal = async ( id: string, status: 'enable' | 'disable' ): Promise<IOkRes> => {

    const { data } = await http.post<IOkRes>( '/cloud/subscriptions/auto-renewal', { id, status });

    return data;

};

export const getSubscriptionById = async ( id: string | number ): Promise<ISubscription> => {

    try {

        const { data } = await http.get<ISubscription>( `/cloud/subscriptions/${id}` );
        return data;

    } catch ( e ) {

        throw new GetUserDataError( 'Failed to get subscription by id' );

    }

};

export const getSubscriptions = async ( status = '', notBefore = 0, options?: Omit<IGetSubscriptionArguments, 'status' | 'not_before'> ): Promise<ICommonRes<ISubscription>> => {

    const queryString = objectToQueryString({
        status: status === '' ? undefined : status,
        not_before: notBefore === 0 ? undefined : notBefore,
        ...options,
    });

    const { data } = await http.get<ICommonRes<ISubscription>>( `/cloud/subscriptions/${queryString}` );
    return data;

};

export const deleteProduct = ( data: ICancelSubscriptionArgs ): Promise<any> => {

    return new Promise(( resolve, reject ) => {

        http.post( `/cloud/subscriptions/cancellation`, data ).then( res => {

            resolve( res );

        }).catch( err => {

            console.error( err );
            reject( err );

        });

    });

};

/**
 * 检查设备是否已存在过订阅
 * 防止设备已经被他人购买过免费套餐，然后换绑了账号
 * @param uid
 * @returns {ICheckDeviceSubscriptionResponse['hasSubscribed']} true - 存在订阅，false - 不存在订阅
 */
export const checkDeviceHadSubscription = async ( uid: string ): Promise<ICheckDeviceSubscriptionResponse['hasSubscribed']> => {

    const { data } = await http.post<ICheckDeviceSubscriptionResponse>( `/cloud/devices/subscriptions/check`, {
        uid
    });

    return data.hasSubscribed;

};

/**
 * 获取用户账号下绑定的所有锁卡设备及对应的iccid
 * @returns
 */
export const getIccidByUid = async ( ): Promise<IEsim[]> => {

    const { data } = await http.get<ICommonRes<IEsim>>( `/devices/esim` );
    return data.items;

};
